import { Text } from "@aidron/aidron-ds";
import PropTypes from 'prop-types';

export function TableColumnTitle({ label, breakWords }) {

  return (
    <Text
      className={`text-center font-size-16px ${breakWords ? "white-space-break-spaces" : ""}`}
      style={{ whiteSpace: "pre-wrap" }}>
      {label}
    </Text>
  );
};

TableColumnTitle.propTypes = {
  label: PropTypes.string,
  breakWords: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.oneOf([undefined])
  ])
}